import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import {FlatList, Pressable, SafeAreaView, View} from "react-native";
import React, {useContext, useEffect, useRef, useState} from "react";
import { Image} from "react-native";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import Text from "../components/Text";
import FontAwesome from "../components/FontAwesome";
import { AppFunctionsContext } from "../../../contexts/AppFunctionsContext";
import { navigate } from "../../../refrences/RootNavigation";


export default function HeaderNotCategory(props: {menuDetails: MenuDetails | undefined}) {
    const config = useContext(AppConfigContext);
    const colors = Colors.instanceNoServerColor(config.theme, "#376864");
    const appFunctions = useContext(AppFunctionsContext);

    return (
        <View style={{padding: "8px"}}>
            <View style={{display: "flex", flexDirection: "row", backgroundColor: colors.get("highConHeader") as string, borderRadius: 15, shadowOpacity: 0.1, shadowRadius:4, shadowOffset: {height: 2, width: 2}} }>
                <View>
                    {props.menuDetails != null ? <Image style={{
                                width: 60,
                                height: 60,
                                margin: "8px",
                                borderRadius: 13,
                                
                            }} source={{uri: props.menuDetails.branchInfo.logoUrl}}/> : <></>}
                </View>
                
                <View style={{
                    flexGrow: 1,
                    justifyContent: "center",
                    alignItems: "flex-start",
                    paddingBottom: 2
                }}>
                    {props.menuDetails != null ? <Text size={18} style={{color:colors.get("primaryColor") as string}} weight={600}>
                        {props.menuDetails.branchInfo.storeName}
                        </Text> : <></>}
                    <Text size={12} style={{color:colors.get("primaryColor") as string,fontFamily:"IRANSans_Medium"}}>آماده پذیرش سفارشات</Text>
                </View>
                
                <View style={{
                    padding: 8,
                    flexDirection: "row",
                    gap: 10,
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft:10
                }}>
                    <Pressable onPress={()=>navigate("BranchInfoScreen", {
                    branchInfo: props.menuDetails?.branchInfo
                })} style={{borderColor:colors.get("primaryColor") as string, borderWidth:1, borderRadius: 10,padding:6.9}}><FontAwesome icon={''} color={colors.get("primaryColor") as string} type={"solid"} size={20}/></Pressable>
                    <Pressable onPress={()=>navigate("BranchWorkingTime", {
                    branchInfo: props.menuDetails?.branchInfo
                })} style={{borderColor:colors.get("primaryColor") as string, borderWidth:1, borderRadius: 10,padding:6.9}}><FontAwesome icon={''} color={colors.get("primaryColor") as string} type={"solid"} size={20}/></Pressable>
                </View>

            </View>
        </View>
    );
};
